import React, { useEffect } from 'react';

// Aviso fijo arriba de la pantalla: se ve aunque la parte de la página
// donde ocurrió la operación quede fuera de vista. Se cierra solo.
export default function AvisoRestaurante({
  mensaje,
  tipo = 'ok',
  onCerrar,
  segundos = 8,
}) {
  useEffect(() => {
    if (!mensaje) return undefined;

    const espera = setTimeout(() => onCerrar?.(), segundos * 1000);

    return () => clearTimeout(espera);
  }, [mensaje, segundos, onCerrar]);

  if (!mensaje) return null;

  const colores =
    tipo === 'error'
      ? 'border-red-300 bg-red-50 text-red-800'
      : 'border-emerald-300 bg-emerald-50 text-emerald-900';

  return (
    <div className="pointer-events-none fixed inset-x-0 top-4 z-[130] flex justify-center px-4">
      <div
        role="status"
        className={`pointer-events-auto flex max-w-xl items-start gap-3 rounded-xl border px-5 py-3 text-sm font-bold shadow-lg ${colores}`}
      >
        <span>{mensaje}</span>

        <button
          type="button"
          onClick={onCerrar}
          aria-label="Cerrar aviso"
          className="text-lg leading-none opacity-60 hover:opacity-100"
        >
          ×
        </button>
      </div>
    </div>
  );
}
